<!-- 
    On parent component, there may be a property used to know which accordion display his content.
    But this property is also in this list-grid component and use to display the accordion-item according to the numToDisplay.
    Todo in parent component to synchronize the two properties :
        * Add a ref attribute on the list-grid component
        * @displayNum event has to put the num value on itemDisplayed property (it can be another name)
        * To attribute accordion displayed num on itemDisplay property, use the displayNum method on this component with the $refs property.
            Exemple : this.$refs.listItems.displayNum(0)
        * WARNING : $refs is created after mounted component. So, you can't use $refs in mounted or created methods.
 -->
<template>
  <div>
    <div
      :class="
        'text-lg text-gray-600 grid place-content-center gap-x-4 ' +
          heightLine +
          ' ' +
          grid
      "
    >
      <slot name="header" />
    </div>

    <slot name="errorCases" />

    <div
      v-if="loading"
      class="w-full h-full flex justify-center items-center"
    >
      <span class="p-7 border-t-2 border-r-2 rounded-full animate-spin border-indigo-600" />
    </div>

    <div v-if="isListdisplayed && !loading">
      <accordion-item
        v-for="(item, num) in listItems"
        :key="labelKey + (item.id ? item.id : num)"
        :class="{
          'odd:bg-indigo-100 odd:bg-opacity-50 bg-white': !disabled(item),
          'odd:bg-indigo-100 bg-opacity-50 bg-white opacity-50': disabled(item)
        }"
        :disabled="disabled(item)"
        style="padding: 0 !important"
        @clickOnItem="!disabled(item) ? displayNum(num) : displayDis(num)"
        :is-accordion-displayed="numToDisplay === num"
        :grid="grid"
        :height-line="heightLine"
      >
        <template #description>
          <slot
            name="accordionDescription"
            :item="item"
            :num="num"
          />
        </template>
        <template #content>
          <slot
            name="accordionContent"
            :item="item"
            :num="num"
          />
        </template>
      </accordion-item>
    </div>
  </div>
</template>

<script>
import AccordionItem from './AccordionItem.vue';

export default {
  components: {
    AccordionItem,
  },

  props: {
    disabled: {
      type: Function,
      required: false,
      default: () => false
    },

    grid: {
      type: String,
      required: false,
      default: 'grid-cols-12',
    },

    listItems: {
      type: Array,
      required: true,
    },

    isListdisplayed: {
      type: Boolean,
      required: false,
      default: true,
    },

    isAccordionItems: {
      type: Boolean,
      required: false,
      default: false,
    },

    heightLine: {
      type: String,
      required: false,
      default: 'h-16 lg:h-24 2xl:h-32',
    },

    labelKey: {
      type: String,
      required: false,
      default: '',
    },

    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      numToDisplay: -1,
    };
  },

  methods: {
    displayNum(num, forceDisplay = false) {
      if (!this.isAccordionItems) {
        return;
      }

      if (this.numToDisplay === num && !forceDisplay) {
        this.$emit('displayNum', -1);
        this.numToDisplay = -1;
        return;
      }
      this.$emit('displayNum', num);
      this.numToDisplay = num;
    },
    
    displayDis(num) {
      this.$emit('displayDis', num);
    }
  },
};
</script>
